<template>

    <div class="position-fixed bg-primary w-100 px-3 py-25 d-xl-none bottom-cart" v-if="counter > 0" @click="openCart">
        <div class="d-flex">
            <div class="pt-1">
                <img  width="26" height="26" src="/images/cart-light.svg" alt="icona" />
            </div>
            <div class="flex-grow-1 text-white pt-1 pl-3">{{$root.translateString('your_cart')}} ({{counter}})</div>
            <div class="">
                <a @click="openCart" href="javascript:void(0)"><img width="7" height="25" src="/images/dx-01-light.svg" alt="icona"/></a>
            </div>
        </div>
    </div>

</template>

<style>

    .bottom-cart{
        bottom:0px;
        z-index: 10;
    }

</style>

<script>
    export default {
    props: ['initCounter'],
    data() {
        return {
            shake:false,
            counter: 0,
            show: false,
        }
    },
    watcher: {
      counter: function(n, o) {
          if(n > 0 && o == 0) {

          }
      }
    },
    mounted() {
        this.counter = parseInt(this.initCounter);

        if(this.counter > 0) {
            setTimeout(() => {
                this.show = true;
            }, 700)
        }

        this.$eventHub.$on('cart.added', payload => {
            this.counter = parseInt(payload.count);
            this.shake = true;

            setTimeout(() => {
                this.shake = false;
            }, 1000);
        });

        this.$eventHub.$on('cart.updated.simpleQty', payload => {
            this.counter = payload;
        });

    },
    methods: {
      openCart() {
          if($(window).width() < 992) {
              window.location.href = this.$root.langRoute('/carrello');
          }else{
              this.$eventHub.$emit('cart.show', {});
          }
      },
      getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.counter = response.data.count;
            })
        },
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }
            return tmp;
        },
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
}
</script>
